/**
 * @file automatically generated from MApp.Endpoints.WorkflowContentController
 */

import { MetadataClient } from '../metadataClient';
import { ISaveWorkflow, IWorkflow, IWorkflowListItem, IValidationResult, IWorkflowNodeListItem } from '../models';

export class WorkflowContentClient extends MetadataClient {

	public static saveWorkflow(workflow: ISaveWorkflow) {
		return MetadataClient.ajax<string>(
			new Request(MetadataClient.endpointsUrl + `api/v1/studio/content/workflows`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'POST',
				body: JSON.stringify(workflow),
				cache: 'no-cache'
			})
		);
	}

	public static updateWorkflow(id: string, workflow: ISaveWorkflow) {
		return MetadataClient.ajax<any>(
			new Request(MetadataClient.endpointsUrl + `api/v1/studio/content/workflows/${encodeURIComponent(id)}`, {
				headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
				method: 'PUT',
				body: JSON.stringify(workflow),
				cache: 'no-cache'
			})
		);
	}

	public static getWorkflow(id: string) {
		return MetadataClient.ajax<IWorkflow>(
			new Request(MetadataClient.endpointsUrl + `api/v1/studio/content/workflows/${encodeURIComponent(id)}`, {
				cache: 'no-cache'
			})
		);
	}

	public static getWorkflows() {
		return MetadataClient.ajax<IWorkflowListItem[]>(
			new Request(MetadataClient.endpointsUrl + `api/v1/studio/content/workflows`, {
				cache: 'no-cache'
			})
		);
	}

	public static deleteWorkflow(id: string) {
		return MetadataClient.ajax<any>(
			new Request(MetadataClient.endpointsUrl + `api/v1/studio/content/workflows/${encodeURIComponent(id)}`, {
				method: 'DELETE',
				cache: 'no-cache'
			})
		);
	}

	public static isValidWorkflow(name: string) {
		return MetadataClient.ajax<IValidationResult>(
			new Request(MetadataClient.endpointsUrl + `api/v1/studio/content/workflows/isvalid?name=${encodeURIComponent(name)}`, {
				cache: 'no-cache'
			})
		);
	}

	public static getWorkflowNodes(id: string) {
		return MetadataClient.ajax<IWorkflowNodeListItem[]>(
			new Request(MetadataClient.endpointsUrl + `api/v1/studio/content/workflows/${encodeURIComponent(id)}/nodes`, {
				cache: 'no-cache'
			})
		);
	}
}
